export const escalationActionTranslations = {
    en: {
        // Card Title
        escalationAction: "Escalation Action",

        // Form Labels
        actionBy: "Action By",
        actionOn: "Action On",
        selectActionDate: "Select action date",
        action: "Action",
        remark: "Remark",
        uploadDocument: "Upload Document (Optional)",

        // Placeholders
        selectUser: "Select User",
        enterAction: "Enter action",
        enterRemark: "Enter remark",

        // Buttons
        cancel: "Cancel",
        submit: "Submit",
        submitting: "Submitting...",

        // Validation Messages
        actionOnRequired: "Action On is required",
        actionRequired: "Action is required",
        remarkRequired: "Remark is required",
        dateRequired: "Date is required",

        // Snackbar Messages
        escalationActionSuccess: "Escalation action recorded successfully",
        escalationActionFailed: "Failed to update camp",

        // Required Indicator
        required: "*",
    },
    mr: {
        // Card Title
        escalationAction: "वाढीची कारवाई",

        // Form Labels
        actionBy: "द्वारे कारवाई",
        actionOn: "वर कारवाई",
        selectActionDate: "कारवाईची तारीख निवडा",
        action: "कारवाई",
        remark: "शेरा",
        uploadDocument: "दस्तऐवज अपलोड करा (पर्यायी)",

        // Placeholders
        selectUser: "वापरकर्ता निवडा",
        enterAction: "कारवाई प्रविष्ट करा",
        enterRemark: "शेरा प्रविष्ट करा",

        // Buttons
        cancel: "रद्द करा",
        submit: "सबमिट करा",
        submitting: "सबमिट करत आहे...",

        // Validation Messages
        actionOnRequired: "कारवाई आवश्यक आहे",
        actionRequired: "कारवाई आवश्यक आहे",
        remarkRequired: "शेरा आवश्यक आहे",
        dateRequired: "तारीख आवश्यक आहे",

        // Snackbar Messages
        escalationActionSuccess: "वाढीची कारवाई यशस्वीरित्या नोंदवली",
        escalationActionFailed: "शिबिर अद्यतनित करण्यात अयशस्वी",

        // Required Indicator
        required: "*",
    }
};
